import { Validators } from '@angular/forms';

export class EmailValidators {
  static readonly emailUsername = () => Validators.pattern('[^@]+');
  static readonly emailDomain = () => Validators.pattern('[^(@\\s)]+\\.[^(@\\s)]+');
  static readonly fullEmailAddress = () => Validators.pattern('[^@]+@[^(@\\s)]+\\.[^(@\\s)]+');
}
